import React from 'react';
import PropTypes from 'prop-types';
import { VStack, Text, Flex, IconButton, Box } from '@chakra-ui/react';
import Link from '@rsc/ui-components/tailwind/Link';
import { MdArrowForward } from 'react-icons/md';
import SanityBackgroundImage from '../../../atoms/SanityBackgroundImage';

function WhatsNewItem({ title, media, cta }) {
  return (
    <VStack
      as={Link}
      className="flex flex-col items-start relative"
      key={title}
      link={cta}
      sx={{
        '&:hover button': {
          display: 'flex',
        },
      }}
    >
      <SanityBackgroundImage
        image={media?.image}
        gradientGenerator={url =>
          `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 1) 100%), url(${url}), lightgray -155.145px -1.208px / 194.193% 129.866% no-repeat;`
        }
        aspectRatio={{ base: 1, lg: 16 / 9 }}
        w={{ base: '18rem', lg: '32rem' }}
        as={Flex}
        borderRadius="lg"
        width="100%"
        height="100%"
        flexDirection="column"
        pl={[6, null, 10]}
        pr={6}
        pb={[6, null, 10]}
        pt={6}
        transition="filter .1s ease-in-out"
        _hover={{ filter: 'brightness(.6)' }}
        justifyContent="space-between"
      >
        <Box>
          <IconButton
            aria-label="open"
            maxWidth={8}
            height={10}
            borderRadius={30}
            icon={<MdArrowForward size={24} />}
            left="91%"
            display="none"
          />
        </Box>
        <Box>
          <Text color="typography.lighter" as="h2" textStyle="h2">
            {title}
          </Text>
        </Box>
      </SanityBackgroundImage>
    </VStack>
  );
}

WhatsNewItem.propTypes = {
  title: PropTypes.string,
  cta: PropTypes.shape({
    linkType: PropTypes.string,
    href: PropTypes.string,
    internalLink: PropTypes.shape({
      slug: PropTypes.shape({
        current: PropTypes.string,
      }),
    }),
  }),
  media: PropTypes.shape({
    image: PropTypes.shape({
      alt: PropTypes.string,
      asset: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }),
}.isRequired;

export default WhatsNewItem;
